import React from 'react';
import clsx from 'clsx';
import styles from './Checkbox.module.scss';

const Checkbox = ({ className, classes = {}, name, label, disabled, checked, onChange }) => {
  return (
    <label className={clsx(styles.root, className, classes.root)}>
      <input
        className={clsx(styles.input, classes.input)}
        name={name}
        type="checkbox"
        disabled={disabled}
        checked={checked}
        onChange={onChange}
      />
      <span className={clsx(styles.checkmark, classes.checkmark)} />
      <span className={clsx(styles.label, classes.label)}>{label}</span>
    </label>
  );
};

export default Checkbox;
